module.exports = __webpack_public_path__ + "media/images/pin_white-985049b3c8529da67997f5037a4157ff.svg";